import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ElinxHistoryExport.module.scss';

const { Button, DropdownMenu } = vp;

type ExportType = 'pdf' | 'csv' | 'xls' | 'doc' | 'text' | 'json' | 'xml' | 'print';

type SearchFormProps = {
  onExport: (type: ExportType) => void;
};

const ElinxHistoryExport: FunctionComponent<SearchFormProps> = ({ onExport }) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Shared.Transaction.TransactionHistory.TransactionSearchForm',
  });

  const exportOptions: { id: string; label: string; type: ExportType }[] = [
    { id: 'export-PDF-btn', label: t('ExportDd.pdf', { defaultValue: 'PDF' }), type: 'pdf' },
    { id: 'export-CSV-btn', label: t('ExportDd.csv', { defaultValue: 'CSV' }), type: 'csv' },
    { id: 'export-XLS-btn', label: t('ExportDd.xls', { defaultValue: 'XLS' }), type: 'xls' },
    { id: 'export-DOC-btn', label: t('ExportDd.doc', { defaultValue: 'DOC' }), type: 'doc' },
    { id: 'export-Text-btn', label: t('ExportDd.text', { defaultValue: 'Text' }), type: 'text' },
    { id: 'export-JSON-btn', label: t('ExportDd.json', { defaultValue: 'JSON' }), type: 'json' },
    { id: 'export-XML-btn', label: t('ExportDd.xml', { defaultValue: 'XML' }), type: 'xml' },
    { id: 'export-Print-btn', label: t('ExportDd.print', { defaultValue: 'Print' }), type: 'print' },
  ];

  return (
    <div className={styles.dropdownContainer}>
      <DropdownMenu>
        <DropdownMenu.Trigger asChild>
          <Button
            id="export-transactions"
            color="secondary"
            label={t('ExportDd.export', { defaultValue: 'Export' })}
            height="48px"
            borderRadius="10px"
            textSize={1}
            background="white"
            noShadow
            icon="arrowDown"
            iconLocation="right"
            variant="outerShadow"
          />
        </DropdownMenu.Trigger>

        <DropdownMenu.Content align="end">
          {exportOptions.map(({ id, label, type }) => (
            <DropdownMenu.Item
              key={id}
              onSelect={(e) => {
                e.preventDefault();
                onExport(type);
              }}
            >
              {label}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu>
    </div>
  );
};

export default ElinxHistoryExport;
